import Cookies from "js-cookie";

/**
 * Šalje page_view događaj Google Analytics-u, ako je gtag aktivan i korisnik dao pristanak.
 * @param url Putanja koju korisnik trenutno vidi (npr. "/cart", "/checkout")
 */
export const trackPageView = (url: string): void => {
  if (!Cookies.get("cookie_consent") || typeof window.gtag !== "function")
    return;
  setTimeout(() => {
    const pageTitle = document.title || "No Title";
    window.gtag?.("event", "page_view", {
      page_path: url,
      page_title: pageTitle,
    });
  }, 100); // mala pauza (100ms) da SEO ima vremena da se postavi
};

/**
 * Šalje događaj u Google Analytics ako je gtag aktivan i korisnik je dao pristanak.
 * @param eventName Ime događaja (npr. "login", "add_to_cart")
 * @param eventParams Parametri događaja (npr. { method: "email" })
 */
export const trackEcommerceEvent = (
  eventName: string,
  eventParams?: Record<string, any>
): void => {
  /**
   * Proverava da li korisnik ima cookie pristanak i da li je gtag dostupan.
   */
  if (!Cookies.get("cookie_consent") || typeof window.gtag !== "function")
    return;

  window.gtag("event", eventName, eventParams || {});
};

// --------------- E-COMMERCE EVENTS EXAMPLES ------------------
// add_to_cart

//   trackEvent("remove_from_cart", {
//     currency: "EUR",
//     value: item.price,
//     items: [item],
//   });

//   trackEvent("begin_checkout", {
//     currency: "EUR",
//     value: total,
//     items: cartItems,
//   });

// export const trackPurchase = ({
//   transaction_id,
//   value,
//   tax,
//   shipping,
//   items,
// }: {
//   transaction_id: string;
//   value: number;
//   tax?: number;
//   shipping?: number;
//   items: any[];
// }) => {
//   trackEvent("purchase", {
//     transaction_id,
//     currency: "EUR",
//     value,
//     tax: tax || 0,
//     shipping: shipping || 0,
//     items,
//   });
// };

// export const trackViewItem = (item: any) => {
//   trackEvent("view_item", {
//     currency: "EUR",
//     value: item.price,
//     items: [item],
//   });
// };

// export const trackViewItemList = (items: any[], listName: string) => {
//   trackEvent("view_item_list", {
//     item_list_name: listName,
//     items,
//   });
// };
